import React from 'react';

// Simple hover/focus tooltip built with context to avoid overlays
const TooltipCtx = React.createContext({ open: false, setOpen: () => {} });

export const TooltipProvider = ({ children }) => children;

export const Tooltip = ({ children }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <TooltipCtx.Provider value={{ open, setOpen }}>
      <span className="relative inline-flex items-center">
        {children}
      </span>
    </TooltipCtx.Provider>
  );
};

export const TooltipTrigger = ({ asChild, children, ...props }) => {
  const { setOpen } = React.useContext(TooltipCtx);
  const triggerProps = {
    onMouseEnter: () => setOpen(true),
    onMouseLeave: () => setOpen(false),
    onFocus: () => setOpen(true),
    onBlur: () => setOpen(false),
    ...props,
  };
  if (asChild) {
    return React.cloneElement(children, triggerProps);
  }
  return <span {...triggerProps}>{children}</span>;
};

export const TooltipContent = ({ children, side = 'top', className = '', ...props }) => {
  const { open } = React.useContext(TooltipCtx);
  if (!open) return null;

  const sideClasses = side === 'top'
    ? 'bottom-full mb-2 left-1/2 -translate-x-1/2'
    : side === 'bottom'
      ? 'top-full mt-2 left-1/2 -translate-x-1/2'
      : side === 'left'
        ? 'right-full mr-2 top-1/2 -translate-y-1/2'
        : 'left-full ml-2 top-1/2 -translate-y-1/2';

  return (
    <div 
      className={`pointer-events-none absolute z-50 overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-sm text-popover-foreground shadow-md ${sideClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}; 